import AddServiceActionRequest from "./AddServiceActionRequest";

export default class SaveServiceActionRequest extends AddServiceActionRequest {
    public serviceActionId: string = "";
}